import React from 'react';
import { Tenant } from '../../types';
import { useSwitchContext } from './SwitchButtonContext';

const SwitchButton: React.FC = () => {
  const { selectedTenant, setSelectedTenant } = useSwitchContext();

  const handleSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSelectedTenant(value as Tenant);
  };

  return (
    <div>
      <div className='radio-container'>
        <input
          type='radio'
          className='input-radio'
          id='at-radio'
          value='AT'
          checked={selectedTenant === Tenant.AT}
          onChange={handleSelection}
        />
        <label htmlFor='at-radio' className='label-radio'>
          {Tenant.AT}
        </label>
      </div>
      <div className='radio-container'>
        <input
          type='radio'
          className='input-radio'
          id='de-radio'
          value='DE'
          checked={selectedTenant === Tenant.DE}
          onChange={handleSelection}
        />
        <label htmlFor='de-radio' className='label-radio'>
          {Tenant.DE}
        </label>
      </div>
    </div>
  );
};

export default SwitchButton;
